<template>
  <div
    class="swiper-container"
    ref="container"
    @mouseenter="stop"
    @mouseleave="goOn"
  >
    <ul
      class="swiper-img"
      :style="{
        width: imgList.length * 100 + '%',
        marginLeft,
      }"
    >
      <li v-for="item in imgList" :key="item.id" @click="handleClick(item)">
        <img v-lazy="$global.imgUrl + item.img" :alt="item.title" />
      </li>
    </ul>
    <div class="swiper-cursor" v-if="isCursor">
      <span @click="move('minus', -1)" class="cursor-left" v-if="index > 0"
        >&lt;</span
      >
      <span
        @click="move('add', 1)"
        class="cursor-right"
        v-if="index < imgList.length - 1"
        >&gt;</span
      >
    </div>
    <ul class="swiper-circle" v-if="isCircle">
      <li
        v-for="(item, i) in imgList"
        :key="item.id"
        :class="{ active: index === i }"
        @click="move('', i)"
      ></li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    imgList: {
      type: Array,
      required: true,
    },
    isCursor: {
      type: Boolean,
      default: true,
    },
    isCircle: {
      type: Boolean,
      default: true,
    },
    isAutoPlay: {
      type: Boolean,
      default: true,
    },
    duration: {
      type: Number,
      default: 1000,
    },
  },
  data() {
    return {
      timer: null,
      index: 0,
      containerWidth: 0,
    };
  },
  computed: {
    marginLeft() {
      return (-this.containerWidth) * this.index + "px";
    },
  },
  mounted() {
    this.containerWidth = this.$refs.container.clientWidth;
    if (this.isAutoPlay) {
      this.autoPlay();
    }
  },
  methods: {
    handleClick(e) {
      let routeUrl = this.$router.resolve({
        path: "/msgDetails",
        query: {
          type: 5,
          id: e.articleId + "",
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    move(type, val) {
      if (type === "add") {
        this.index += val;
      } else if (type === "minus") {
        this.index += val;
      } else {
        this.index = val;
      }
    },
    autoPlay() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.move("add", 1);
        if (this.index === this.imgList.length) {
          this.index = 0;
        }
      }, this.duration);
    },
    stop() {
      clearInterval(this.timer);
    },
    goOn() {
      this.autoPlay();
    },
  },
};
</script>
<style lang="scss" scoped>
.swiper-container {
  width: 100%;
  height: 375px;
  overflow: hidden;
  position: relative;
  .swiper-img {
    height: 100%;
    display: flex;
    margin-left: 0;
    transition: all 0.3s;
    li {
      width: 1200px;
      height: 375px;
      cursor: pointer;
      img {
        width: 100%;
        height: 375px;
      }
    }
  }
  &:hover {
    .swiper-cursor {
      display: block;
    }
  }
  .swiper-cursor {
    display: none;
    position: absolute;
    top: 50%;
    width: 100%;
    span {
      position: absolute;
      display: block;
      width: 30px;
      height: 30px;
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 50%;
      line-height: 30px;
      text-align: center;
      color: #ffffff;
      font-weight: bolder;
      cursor: pointer;
    }
    .cursor-left {
      left: 10px;
    }
    .cursor-right {
      right: 10px;
    }
  }
  .swiper-circle {
    width: 200px;
    height: 8px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 12px;
    display: flex;
    justify-content: center;
    li {
      width: 20px;
      height: 100%;
      background-color: rgba(148, 147, 147, 0.5);
      margin: 0 3px;
      border-radius: 3px;
      box-shadow: 0px 7px 15px 1px rgba(6, 10, 82, 0.09);
      cursor: pointer;
      &.active {
        background-color: #ffffff;
      }
    }
  }
}
</style>
